import figures from 'figures';

const icons = {
	pipe: figures.lineDownDoubleRightDouble,
	tool: figures.lineDownLeftBoldRightBold,
	memory: figures.nodejs
};

export default icons;
